// extracted by mini-css-extract-plugin
export var actionButton = "_js-t";
export var buttonContainer = "_js-0";
export var buttonContainer2 = "_js-1";
export var buttonSection = "_js-2";
export var details = "_js-3";
export var dropdownItem = "_js-5";
export var dropdownItemsContainer = "_js-4";
export var fileInput = "_js-r";
export var headerButton = "_js-6";
export var icon = "_js-7";
export var input = "_js-8";
export var macroListItem = "_js-9";
export var mainContent = "_js-a";
export var microText = "_js-b";
export var modal = "_js-w";
export var optionsButton = "_js-c";
export var paperclip = "_js-s";
export var pillContent = "_js-d";
export var preview = "_js-e";
export var preview2 = "_js-f";
export var quillEditor = "_js-q";
export var selectedMacro = "_js-g";
export var sidebar = "_js-h";
export var sidebarHeader = "_js-j";
export var sidebarList = "_js-i";
export var sidebarListItem = "_js-k";
export var sidebarSearch = "_js-l";
export var snoozeDurationWrapper = "_js-v";
export var statusPillContainer = "_js-m";
export var tagsContainer = "_js-n";
export var unselectedMacro = "_js-o";
export var variable = "_js-u";
export var wrapper = "_js-p";